<template>
    <app-cmp-tabs default="box" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import SelectField from '@/components/fields/inputs/Select';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-select': SelectField
        },
        props: {
            element: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            loading: true,
            forms: [],
            fields: {
                form: {
                    name: 'Form',
                    attribute: 'form',
                    options: []
                },
                type: {
                    name: 'Form type',
                    attribute: 'type',
                    options: [
                        {
                            value: 'contact-form',
                            label: 'Contact'
                        },
                        {
                            value: 'booking',
                            label: 'Booking'
                        },
                        {
                            value: 'ask-a-question',
                            label: 'Ask a Question'
                        }
                    ]
                },
            }
        }),

        mounted() {
            this.getForms().then(response => {
                this.loading = false;
            });
        },

        methods: {
            getForms() {
                this.forms = [];
                this.fields.form.options = [];

                return Admin.request().get('/admin-api/composer/forms')
                    .then(({ data }) => {
                        this.forms = data.forms;

                        this.setFormsFields();
                    });
            },

            setFormsFields() {
                this.fields.form.options.push({
                    value: false,
                    label: 'None'
                });

                if (this.forms.length > 0) {
                    for (let i in this.forms) {
                        this.fields.form.options.push({
                            value: this.forms[i].handle,
                            label: this.forms[i].name
                        });
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/NewsSettings.vue